import api from './api'

export interface HashtagTrend {
  hashtag: string
  count: number
}

export interface HashtagPageResponse<T> {
  content: T[]
  totalElements: number
  totalPages: number
  last: boolean
}

const hashtagService = {
  // Trending hashtags across public posts + reels (combined count).
  getTrending: async (limit: number = 20): Promise<HashtagTrend[]> => {
    const response = await api.get(`/hashtags/trending?limit=${limit}`)
    return response.data.data
  },

  // Autocomplete hashtags by prefix (returns bare tag strings).
  search: async (q: string, limit: number = 10): Promise<string[]> => {
    const response = await api.get(`/hashtags/search?q=${encodeURIComponent(q)}&limit=${limit}`)
    return response.data.data
  },

  // Public posts tagged with a hashtag.
  getPostsByHashtag: async (tag: string, page: number = 0, size: number = 15): Promise<HashtagPageResponse<any>> => {
    const response = await api.get(`/hashtags/${encodeURIComponent(tag)}/posts?page=${page}&size=${size}`)
    return response.data.data
  },

  // Public reels tagged with a hashtag.
  getReelsByHashtag: async (tag: string, page: number = 0, size: number = 15): Promise<HashtagPageResponse<any>> => {
    const response = await api.get(`/hashtags/${encodeURIComponent(tag)}/reels?page=${page}&size=${size}`)
    return response.data.data
  }
}

export default hashtagService